import type { TISAUser, Quest } from '@/types/tisa-coins';
import { getActiveQuests } from '@/lib/tisa-helpers';

interface Props {
  user: TISAUser;
  quests: Quest[];
  onRefresh: () => void;
}

export function ActiveQuestsSection({ user, quests }: Props) {
  const activeQuestEvents = getActiveQuests(user.quest_events);
  const activeQuests = activeQuestEvents
    .map(event => quests.find(q => q.id === event.quest_id))
    .filter(Boolean) as Quest[];

  return (
    <div className="bg-gray-900/50 border-2 border-emerald/30 rounded-xl p-6">
      <h2 className="text-2xl font-cinzel font-bold text-emerald mb-4">
        📋 Active Quests ({activeQuests.length})
      </h2>
      {activeQuests.length === 0 ? (
        <p className="text-gray-400 text-center py-8">No active quests. Browse available quests below!</p>
      ) : (
        <div className="space-y-3">
          {activeQuests.map(quest => (
            <div key={quest.id} className="bg-black/30 border border-emerald/20 rounded-lg p-4 hover:border-emerald/50 transition-all">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="font-cinzel font-bold text-white">{quest.title}</h3>
                  <p className="text-sm text-gray-400 mt-1">{quest.description}</p>
                  <div className="flex gap-2 mt-2">
                    <span className="px-2 py-1 bg-emerald/20 text-emerald text-xs rounded">{quest.type}</span>
                    <span className="px-2 py-1 bg-purple/20 text-purple text-xs rounded">{quest.category}</span>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-emerald font-orbitron font-bold text-lg">{quest.xp_reward} XP</p>
                  <button className="mt-2 px-4 py-2 bg-emerald text-white rounded-lg text-sm font-bold hover:bg-emerald/80">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
